import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Row, Col, Radio, Select, Collapse } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import _ from "lodash";
import { ReactSVG } from "react-svg";
import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
} from "react-google-places-autocomplete";

const DirectionPop: FC<{
  setActivePop: (activePop: string) => void;
  showDirections: (locationObj: LocationObj) => void;
  currentLocation: LocationObj;
}> = ({ setActivePop, showDirections, currentLocation }) => {

  const googleSuggestHandler = (place: any) => {
    geocodeByPlaceId(place.place_id)
      .then((results) => {
        if (results[0].geometry) {
          showDirections({
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
            current: false,
          });
        }
      })
      .catch((error) => console.error(error));
  };

  return (
    <div className="pop-content filter-popup">
      <Row className="d-flex mb-4">
        <Col>
          <h3>Direction</h3>
        </Col>
        <Col>
          <CloseOutlined
            className="close-icon"
            onClick={() => setActivePop("")}
          />
        </Col>
      </Row>

      <Row className="mt-3 d-line">
        <Col span={24}>
          <GooglePlacesAutocomplete
            autocompletionRequest={
              {
              }
            }
            selectProps={{
              onChange: (place: any) => {
                if (place) googleSuggestHandler(place.value);
              },
              isClearable: true,
              placeholder: "Search place",
              styles: {
                input: (provided: any) => ({
                  ...provided,
                  fontFamily: "Nunito-Regular",
                }),
                menu: (provided: any) => ({
                  ...provided,
                  position: "relative",
                }),
              },
            }}
            apiKey={"AIzaSyDgNagv_ozKWc6IQ75Ol4cH8fxdntOaW6M"}
          />
        </Col>
      </Row>

      <Row className="mt-3 d-line">
        <Col
          span={24}
          className="location-container"
          onClick={() => {
            showDirections({ ...currentLocation, current: true });
          }}
        >
          <ReactSVG src="/images/location-icon.svg" />
          My location
        </Col>
      </Row>
    </div>
  );
};

export default DirectionPop;
